<form [formGroup]="_formFieldControlService.dynamicFormGroup" (ngSubmit)="_validate()" role="form">
    <terra-base-toolbar
        [ngClass]="{ toolbarHidden: inputHasNoSaveButton && inputHasNoResetButton && !inputHasToggleButton }"
    >
        <div class="btn-group" role="group">
            <terra-button
                [inputIcon]="'icon-save'"
                [inputTooltipText]="'save' | translate: _locale.language"
                [inputType]="'submit'"
                [inputIsHidden]="inputHasNoSaveButton"
            >
            </terra-button>
            <terra-button
                [inputIcon]="'icon-reset'"
                [inputTooltipText]="'reset' | translate: _locale.language"
                (outputClicked)="_onResetClick()"
                [inputIsHidden]="inputHasNoResetButton"
            >
            </terra-button>
        </div>
        <terra-toggle
            [inputTooltipText]="'terraDynamicForm.deprecated' | translate: _locale.language"
            (toggled)="_onToggleClick()"
            [(ngModel)]="inputShowDeprecatedEntries"
            [ngModelOptions]="{ standalone: true }"
            [inputIsHidden]="!inputHasToggleButton"
        >
        </terra-toggle>
    </terra-base-toolbar>

    <div class="container-fluid">
        <div class="row">
            <div [class]="inputPortletStyle">
                <terra-dynamic-switch
                    [inputFormFields]="inputFormFields"
                    [inputUsePortlet]="inputUsePortlet"
                    [inputIsDisabled]="inputIsDisabled"
                    [inputShowDeprecatedConfig]="inputShowDeprecatedEntries"
                    [inputFormGroup]="_formFieldControlService.dynamicFormGroup"
                >
                </terra-dynamic-switch>
            </div>
        </div>
    </div>
</form>
